import { put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import { ICustomElement, IStateCustomDataDisplayState } from '../store/nemsisCustomData.types'
import {
  setCustomDisplayData,
  setMultiInstanceStateCustomElementPNNVValue,
  setStateCustomElementPNNVValue,
  setStateCustomElementValue,
} from '../store/nemsisCustomData.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'
import { randomNumber } from '../../../utilities'

export function* duplicateCustomElement() {
  try {
    const customDisplayData: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)
    const { state, groupKey, customElementId, stateCustomElements, groupingSequence, key } = customDisplayData
    const copyCustomElements = [...stateCustomElements]
    const updatedStateCustomElements = copyCustomElements.map((stateElements) => {
      if (state !== stateElements.state) {
        return stateElements
      }

      const updatedGroups = stateElements.groups.map((group) => {
        if (group.groupKey === groupKey && group.groupingSequence === groupingSequence) {
          const groupOfCurrentCustomElements = group?.customElements?.filter(
            (customEle) => customEle.id === customElementId
          )
          const lastCustomElement = groupOfCurrentCustomElements[groupOfCurrentCustomElements.length - 1]

          const updatedCustomElements = group?.customElements?.reduce<ICustomElement[]>((acc, customElement) => {
            if (customElement.id === customElementId && customElement.key === key) {
              const { results, resultsPNNV, ...rest } = customElement
              const duplicatedElement: ICustomElement = {
                ...rest,
                key: randomNumber().toString(),
                customElementSequence: lastCustomElement?.customElementSequence + 1,
                _pnnvToggle: false,
                isDuplicated: true,
                results: [],
                resultsPNNV: null,
              }

              acc.push(customElement)
              acc.push(duplicatedElement)
            } else {
              acc.push(customElement)
            }
            return acc
          }, [])
          return {
            ...group,
            customElements: updatedCustomElements,
          }
        }

        return group
      })

      return {
        ...stateElements,
        groups: updatedGroups,
      }
    })
    yield put(setCustomDisplayData(updatedStateCustomElements))
    yield put(setStateCustomElementValue(null, {}))
    yield put(setStateCustomElementPNNVValue(null, {}))
    yield put(setMultiInstanceStateCustomElementPNNVValue(null, {}))
  } catch (e) {
    yield put(throwPcrException(`duplicateCustomElement() error: ${e}`))
  }
}

export function* duplicateCustomElementSaga() {
  yield takeLatest([StateCustomDataConstants.DUPLICATE_CUSTOM_ELEMENT], performWithMutexHOG, duplicateCustomElement)
}
